export default __webpack_public_path__ + "static/media/ca.de31f9e7.svg";